'use strict';

import Collapse from 'bootstrap/js/dist/collapse';
import Modal from 'bootstrap/js/dist/modal';
import Splide from '@splidejs/splide';

// Hamburger
const hamburger = document.querySelector(".hamburger");

if (hamburger) {
  hamburger.addEventListener("click", () => {
    hamburger.classList.toggle("is-active");
  });
}


// Page logic
if(page === "main"){

  const secOthers = document.querySelector("#sectionOthers");
  const othersSplide = document.getElementById('othersSplide');

  if (secOthers && othersSplide) {
    new Splide(othersSplide, {
      perPage: 2,
      rewind: false,
      type: 'loop',
      pagination: false,
      gap: '2rem',
      breakpoints: {
        768: {
          perPage: 1,
          gap: '.7rem',
        }
      },
    }).mount();
  }

  const submit = document.getElementById("senden");
  const checkbox = document.querySelector('input[name="dsgvo"]');
  const formular = document.getElementById("form");

  if (submit && checkbox) {
    submit.disabled = !checkbox.checked;

    checkbox.addEventListener('click', () => {
      submit.disabled = !checkbox.checked;
    });
  }

  if (submit) {
    submit.addEventListener("click", sendeFormular);
  }
}

// Email validation
function validateEmail(email) {
  return /\S+@\S+\.\S+/.test(email);
}

function validate() {
  const inputs = document.querySelectorAll('.input');
  inputs.forEach(i => i.classList.remove('not-valide'));

  const formular = document.getElementById("form");
  let error = false;

  if (!formular.name.value) {
    formular.name.classList.add("not-valide");
    error = true;
  }

  if (!formular.email.value || !validateEmail(formular.email.value)) {
    formular.email.classList.add("not-valide");
    error = true;
  }

  if (!formular.text.value) {
    formular.text.classList.add("not-valide");
    error = true;
  }

  return !error;
}

function sendeFormular() {
  if (!validate()) return;

  const formular = document.getElementById("form");

  const XHR = new XMLHttpRequest();
  XHR.open("POST", "ajax-form.php?data", true);

  const daten = new FormData(formular);
  XHR.send(daten);

  XHR.onreadystatechange = function () {
    if (XHR.readyState === 4 && XHR.status === 200) {

      const data = JSON.parse(XHR.responseText);
      let error = false;

      if (!data.success) {
        data.error.forEach(item => {
          const el = formular.querySelector(`[name="${item}"]`);
          if (el) el.classList.add("not-valide");
          error = true;
        });
      }

      document.getElementById("ausgabe").innerHTML = data.meldung;

      if (!error && !data.error_mail) {
        formular.reset();
      }
    }
  };
}

// Navbar collapse
window.addEventListener('DOMContentLoaded', () => {
  const navLinks = document.querySelectorAll('.nav-item');
  const menuToggle = document.getElementById('navbarSupportedContent');

  if (!menuToggle) return;

  const bsCollapse = new Collapse(menuToggle, { toggle: false });

  navLinks.forEach((l) => {
    l.addEventListener('click', () => {
      bsCollapse.toggle();
      hamburger?.classList.toggle("is-active");
    });
  });
});

// Parallax fix
function fg_parallax() {
  const elements = document.querySelectorAll('.fg-parallax');
  let zIndex = 1;

  elements.forEach(item => {
    item.style.zIndex = zIndex++;
  });
}

window.addEventListener('load', fg_parallax);

// Smooth scroll
document.addEventListener('click', (ev) => {
  if (ev.target.classList.contains('no-hash')) {
    ev.preventDefault();
    document.querySelector(`[name="${ev.target.dataset.link}"]`)
      ?.scrollIntoView({ behavior: 'smooth' });
  }
});

// Language toggle
function sprache() {
  const buttons = document.querySelectorAll('.toogleLanguage');
  const content = document.querySelectorAll('.contentSprache');

  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      content.forEach(el => el.classList.toggle('d-none'));
    });
  });
}

document.addEventListener('DOMContentLoaded', sprache);

document.addEventListener('DOMContentLoaded', function () {
  const modalElement = document.getElementById('teamMemberModal');
  const modalTitle = document.getElementById('teamMemberModalLabel');
  const modalBody = document.getElementById('teamMemberModalBody');
  const aboutSplideElement = document.getElementById('aboutTeamSplide');

  let teamModal = null;

  if (modalElement) {
    teamModal = new Modal(modalElement);
  }

  function fillTeamModal(memberId) {
    const member = window.teamMembers.find(item => item.id === memberId);
    if (!member) return false;

    const fullName = [member.first_name, member.last_name].join(' ');

    // Bildpfade bauen (wie in PHP)
    const imageWebp = `${window.siteUrl}/images/${member.image}.webp`;
    const imageJpg  = `${window.siteUrl}/images/${member.image}.jpg`;

    const pictureHtml = `
      <picture>
        <source srcset="${imageWebp}" type="image/webp">
        <source srcset="${imageJpg}" type="image/jpeg">
        <img 
          src="${imageJpg}" 
          alt="${fullName}" 
          class="team-modal-image rounded-circle"
          style="width: 64px; height: 64px; object-fit: cover;"
        >
      </picture>
    `;

    modalTitle.innerHTML = `
      <div class="team-modal-head d-flex align-items-center gap-3">
        ${pictureHtml}
        <div>
          <div class="team-modal-name">${fullName}</div>
          ${member.position ? `<div class="team-modal-position">${member.position}</div>` : ''}
        </div>
      </div>
    `;

    modalBody.innerHTML = `
      <div class="team-modal-text">
        ${member.modal_html || ''}
      </div>

      ${
        member.linkedin
          ? `
          <div class="team-modal-linkedin mt-4">
            <a href="${member.linkedin}" target="_blank" rel="noopener" class="text-decoration-none linkBlauLinkedin">
              <img src="${window.siteUrl}/images/linkedin.svg"
                              alt="LinkedIn ${fullName}"
                              width="24"
                              height="24"
                            > LinkedIn profile
            </a>
          </div>
        `
          : ''
      }
    `;

    return true;
  }

  if (aboutSplideElement && typeof Splide !== 'undefined') {
    const aboutSplide = new Splide(aboutSplideElement, {
      type: 'loop',
      perPage: 4,
      perMove: 1,
      gap: '2rem',
      pagination: false,
      arrows: false,
      focus: 0,
      start: 0,
      autoplay: false,
      keyboard: true,
      drag: true,
      snap: true,
      breakpoints: {
        1399: {
          gap: '1.5rem'
        },
        1199: {
          perPage: 3,
          gap: '1.25rem'
        },
        767: {
          destroy: true
        }
      }
    });

    aboutSplide.mount();

    const prevButton = aboutSplideElement.querySelector('.about-team-arrow--prev');
    const nextButton = aboutSplideElement.querySelector('.about-team-arrow--next');

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        aboutSplide.go('<');
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        aboutSplide.go('>');
      });
    }

    let pointerDownX = 0;
    let pointerDownY = 0;
    let pointerMoved = false;

    const triggers = aboutSplideElement.querySelectorAll('.js-team-modal-trigger');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('pointerdown', function (event) {
        pointerDownX = event.clientX;
        pointerDownY = event.clientY;
        pointerMoved = false;
      });

      trigger.addEventListener('pointermove', function (event) {
        const deltaX = Math.abs(event.clientX - pointerDownX);
        const deltaY = Math.abs(event.clientY - pointerDownY);

        if (deltaX > 8 || deltaY > 8) {
          pointerMoved = true;
        }
      });

      trigger.addEventListener('click', function (event) {
        event.preventDefault();

        if (pointerMoved) {
          pointerMoved = false;
          return;
        }

        const memberId = trigger.getAttribute('data-member-id');
        const success = fillTeamModal(memberId);

        if (success && teamModal) {
          teamModal.show();
        }
      });
    });
  }

  // Falls Desktop-Slider zerstört ist und Trigger außerhalb Splide noch existieren
  document.querySelectorAll('.js-team-modal-trigger').forEach(function (trigger) {
    if (trigger.dataset.teamModalBound === '1') {
      return;
    }

    trigger.dataset.teamModalBound = '1';

    let startX = 0;
    let startY = 0;
    let moved = false;

    trigger.addEventListener('pointerdown', function (event) {
      startX = event.clientX;
      startY = event.clientY;
      moved = false;
    });

    trigger.addEventListener('pointermove', function (event) {
      const deltaX = Math.abs(event.clientX - startX);
      const deltaY = Math.abs(event.clientY - startY);

      if (deltaX > 8 || deltaY > 8) {
        moved = true;
      }
    });

    trigger.addEventListener('click', function (event) {
      event.preventDefault();

      if (moved) {
        moved = false;
        return;
      }

      const memberId = trigger.getAttribute('data-member-id');
      const success = fillTeamModal(memberId);

      if (success && teamModal) {
        teamModal.show();
      }
    });
  });
});